import bus from "@/core/api/bus"
import logger from "@/core/logger"
import ev1state from "@/core/ev1/state"
import createRequestBuilder from "./request"
import { getDebugRequest } from "./debug"

export async function addSegment(segment: string): Promise<void> {
  if (segment) {
    await createRequestBuilder().setSegmentCodes([segment]).send({ skipPageViews: true })
    bus.emit("setsegments", { segment })
    return
  }
  logger.info("No segment code given.")
}

export function getForcedSegments() {
  const debugCookie = getDebugRequest()
  return Array.isArray(debugCookie?.fs) ? debugCookie.fs : []
}

export const getSegments = ev1state(({ segments }) => {
  const segmentIds = segments.active_segments.map(segment => segment.id)
  const forcedSegments = getForcedSegments()
  return [...new Set([...forcedSegments, ...segmentIds])]
})
